
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Отворите мени вашег прегледача`,
's182ab2d6c997515f': `Додајте га на Home Screen за широке могућности и лак приступ.`,
's1b9047d53d9f9d22': `2) Притисните Share у навигационој траци`,
's2d90afa5dcca2c0e': `3) Померите се надоле до "Add to Home Screen"`,
's37a9e8aec5713460': `Више`,
's4593f304dac8848c': `2) Додирните "Add to Home Screen"`,
's54cfbb14f46396d4': `1) Отворите у вашем главном прегледачу`,
's6196153c4b0c1ea0': `Инсталирај`,
'sa5ef80b4bb9b39f8': `Мање`,
'sa7551383d1897fcc': `3) Притисните Add to Dock`,
'sba52286c21552a4e': `Инсталирајте га на вашем уређају за широке могућности и лак приступ.`,
'sc79fd7641eb9a975': `Сакриј упутство`,
'se740f75b95a51807': `Додајте га у вашу Dock за широке могућности и лак приступ.`,
'sfea652f6580ff086': `Овај сајт има функционалност апликације.`,
's922329d6f6213590': `Add to Dock`,
'scdaf4bbff76674c8': `Add to Home Screen`,
    };
  